import { render, staticRenderFns } from "./index.vue?vue&type=template&id=03df7654&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=03df7654&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03df7654",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/chillzon/Documents/projects/crmeb_view/mer_plat_admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('03df7654')) {
      api.createRecord('03df7654', component.options)
    } else {
      api.reload('03df7654', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=03df7654&scoped=true", function () {
      api.rerender('03df7654', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/videoChannel/weChatcategoryAndBrand/index.vue"
export default component.exports